<template>
  <div :class="$style.container">
    <h1 :class="$style.heading">{{ title }}</h1>
    <SearchBarSmallScreenHg />
    <MapLegend v-if="!isDataLayerExpanded" mode="flat" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import MapLegend from '@/components/map/mapbox/MapLegend.vue';
import { SearchBarSmallScreenHg } from '@/components/search-bar';
import useDynamicTitle from '@/composables/useDynamicTitle';
import useMapStore from '@/stores/useMapStore';

const { isDataLayerExpanded } = storeToRefs(useMapStore());

const { getDynamicTitle } = useDynamicTitle();
const title = computed(() => getDynamicTitle());
</script>

<style lang="scss" module>
@use '@/styles/variables' as *;

.container {
  position: absolute;
  top: 0;
  z-index: $hg-mobile-search-header-zindex;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: $space-100;
  background-color: $color-white;

  @include grid-media-query(sm) {
    display: none;
  }
}

.heading {
  margin-top: 0;
  margin-bottom: $space-100;

  @include grid-media-query(sm) {
    display: none;
  }

  @include heading-1;
}
</style>
